enum ListStyles {
	Ordered = 'ordered',
	Unordered = 'unordered',
	Definition = 'definition'
}

export default ListStyles
